import Vue from 'vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import Vant, { Toast } from 'vant'
import 'vant/lib/index.css'
import './style/index.css'
import './style/common.less'
import 'amfe-flexible/index.min.js'
import * as moment from '@/utils/filter'
import App from './App.vue'
Vue.use(Vant)
Vue.use(Toast)

Vue.prototype.$Axios = Axios

Vue.prototype.$base = process.env.VUE_APP_IMAGE_URL
// 定义全局的时间过滤器
Object.keys(moment).forEach(key => { Vue.filter(key, moment[key]) })

// 将所有 Toast 的展示时长设置为 2000 毫秒
Toast.setDefaultOptions({ duration: 2000 })
Vue.config.productionTip = false
// 延迟加载
/* eslint-disable */
Vue.prototype.$delay = (time) => {
  return new Promise((re) => {
    setTimeout(() => {
      re()
    }, time)
  })
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
